module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"interact":"Interact with this environment to discover the HELIX collection"},"fr":{"interact":"Interagissez avec cet environnement pour découvrir la collection HELIX."},"pl":{"interact":"Zainspirowane naturą - odkryj i sprawdź kolekcję HELIX"},"de":{"interact":"Interagieren Sie mit der Umgebung, um die HELIX Kollektion zu entdecken"}}')
  delete Component.options._Ctor
}
